import { put, call, all, takeEvery } from 'redux-saga/effects'
import { store as reduxStore } from 'index'
import { getInsightsData } from 'services/analytics'
import { getBillingCycleUsage as getBillingCycleUsageMetrics } from 'services/operationalData'
import { requestBillingUsage as requestMultiTenantBillingUsage } from 'services/multiTenant'
import actions from './actions'

export function* GET_USAGE_AND_OVERAGES() {
  yield put({
    type: actions.SET_STATE,
    payload: { appUsageAndOveragesLoading: true },
  })

  const activeApp = reduxStore.getState().apps.active

  try {
    const success = yield call(getBillingCycleUsageMetrics, activeApp)

    if (success && success.data) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          appUsageAndOverages: success.data,
          appUsageAndOveragesLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          appUsageAndOverages: [],
          appUsageAndOveragesLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: { appUsageAndOveragesLoading: false },
    })
    window.triggerNotification('Failed to fetch usage data', 'error')
  }
}

export function* GET_INSIGHTS_DATA() {
  const activeApp = reduxStore.getState().apps.active

  try {
    const success = yield call(getInsightsData, activeApp)

    if (success && success.data) {
      yield put({
        type: actions.SET_STATE,
        payload: { fetchedInsightsData: success.data },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: { fetchedInsightsData: [] },
      })
    }
  } catch (error) {
    window.triggerNotification('Failed to fetch insights data', 'error')
  }
}

export function* MULTITENANT_GET_USAGE() {
  yield put({
    type: actions.SET_STATE,
    payload: { appUsageAndOveragesLoading: true },
  })

  const activeApp = reduxStore.getState().apps.active

  try {
    const success = yield call(requestMultiTenantBillingUsage, activeApp)

    if (success && success.data) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          appUsageAndOverages: success.data,
          appUsageAndOveragesLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          appUsageAndOverages: [],
          appUsageAndOveragesLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: { appUsageAndOveragesLoading: false },
    })
    window.triggerNotification('Failed to fetch usage data', 'error')
  }
}

export default function* billingSaga() {
  yield all([
    takeEvery(actions.GET_USAGE_AND_OVERAGES, GET_USAGE_AND_OVERAGES),
    takeEvery(actions.GET_INSIGHTS_DATA, GET_INSIGHTS_DATA),
    takeEvery(actions.MULTITENANT_GET_USAGE, MULTITENANT_GET_USAGE),
  ])
}
